module.exports = __webpack_public_path__ + "static/media/social-medium.1e564e15.svg";